import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import {
  Card,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableSortLabel,
  Typography,
  Button,
  TextField,
  MenuItem
} from '@material-ui/core';
import { Breadcrumb, BackdropCircular} from 'components';
import { updateRequestRestrictAccessApi } from 'api';
import { useStyles } from '../styles';
import MassEditRequestAccessRow from './MassEditRequestAccessRow';


const MassEditRequestAccess = ({location}) => {
  const { checkedCustomers } = location?.state || {checkedCustomers: []};
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const {loadingRequestAccessList} = useSelector((state) => state.customers);
  const {isEnabledRequestAccess} = useSelector((state) => state.store_configs);
  const [dynamicAccessStatus, setDynamicAccessStatus] = useState('');

  useEffect(() => {
    if (!isEnabledRequestAccess) {
      history.push('/');
    }
  }, []);

  const handleSave = async () => {
    const updatedParamsAccess = checkedCustomers.map((row) => ({ id: row.id, request_access: dynamicAccessStatus, }));

    const isUpdated = await updateRequestRestrictAccessApi({dispatch, updatedParamsAccess});

    if (isUpdated) {
      history.push('/customers/request-access');
    }
  };

  return (
    <div className="scroll-y pb-5">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Customers'},
            { name: 'Request Access List', path: '/customers/request-access'},
            { name: 'Bulk Edit Request Access'},
          ]}
        />
      </div>
      <div className="flex justify-end pr-10">
        <Typography>
          <div className="flex items-center mr-10">
            <span className="mr-3">Manage Access:</span>
            <TextField
              select
              variant="outlined"
              className="w-140"
              value={dynamicAccessStatus}
              onChange={(event) => setDynamicAccessStatus(event.target.value)}
              label="select"
            >
              <MenuItem value="access_restricted">Restrict</MenuItem>
              <MenuItem value="access_granted">Grant</MenuItem>
            </TextField>
          </div>
        </Typography>
        <Button
          type="button"
          color="primary"
          variant="contained"
          className="uppercase custom-check-all custom-check-all-select"
          title="Click here to save all changes"
          onClick={handleSave}
          disabled={!dynamicAccessStatus}
        >
          Save All & go back
        </Button>
      </div>
      <div>
        <Card className="mx-10 mt-10">
          <div className="table-container">
            <TableContainer>
              <Table aria-label="table" className={classes.tableRequestAccess} >
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <TableSortLabel>
                        Customer ID
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel>
                        Email
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel>
                        First name
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel>
                        Last name
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel>
                        Customer Group
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel>
                        Request Access Status
                      </TableSortLabel>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!checkedCustomers?.length ?
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        No matching customers found. <br />
                        Please, go to
                        <Link
                          to="/customers/request-access"
                          className="w-full m-3 underline custom_link"
                        >
                          Request Access List page
                        </Link>
                        and check customers.
                      </TableCell>
                    </TableRow>
                    :
                    <>
                      {checkedCustomers.map((checkedRowData) => {
                        return (
                          <MassEditRequestAccessRow
                            key={checkedRowData.id}
                            checkedRowData={checkedRowData}
                            dynamicAccessStatus={dynamicAccessStatus}
                          />
                        );
                      })
                      }
                    </>
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Card>
        <BackdropCircular loading={loadingRequestAccessList} />
      </div>
    </div>

  );
};

export default MassEditRequestAccess;
